import { NavItem } from './nav-item.model';
import { NavSection } from './nav-section.model';

export const PORTAL_SECTIONS: NavSection[] = [
  {
    label: 'Principal',
    items: [
      { label: 'Inicio', icon: 'pi pi-home', route: '/portal/dashboard' },
      { label: 'Pagar', icon: 'pi pi-bolt', external: 'https://similpay.com/#/biller_code/18608', variant: 'pill' },
    ],
  },
  {
    label: 'Cupos de Crédito',
    items: [
      { label: 'Mini', icon: 'pi pi-bolt', route: '/portal/cupos-credito/mini' },
      { label: 'Amigo', icon: 'pi pi-users', route: '/portal/cupos-credito/amigo' },
      { label: 'Plus', icon: 'pi pi-star', route: '/portal/cupos-credito/plus' },
      { label: 'Maxi', icon: 'pi pi-chart-line', route: '/portal/cupos-credito/maxi' },
    ],
  },
  {
    label: 'Cupos',
    items: [
      { label: 'Información', icon: 'pi pi-info-circle', route: '/portal/cupos/informacion' },
      { label: 'Mis Cupos', icon: 'pi pi-credit-card', route: '/portal/cupos', requiresCupos: true },
    ],
  },
  {
    label: 'Beneficios',
    items: [{ label: 'Tu beneficio Rayo', icon: 'pi pi-gift', route: '/portal/beneficios' }],
  },
  {
    label: 'Cuenta',
    items: [{ label: 'Perfil', icon: 'pi pi-user', route: '/portal/perfil' }],
  },
];

export const PORTAL_USER_MENU: NavItem[] = [
  { label: 'Mi perfil', icon: 'pi pi-user', route: '/portal/perfil' },
  { label: 'Cerrar sesión', icon: 'pi pi-sign-out', action: 'logout' },
];
